import React, { ReactNode } from 'react';

export type SegmentedOption<T extends string = string> = {
  value: T;
  label: ReactNode;
  icon?: ReactNode;
};

export type SegmentedProps<T extends string = string> = {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (next: T) => void;
  full?: boolean;
};

export function Segmented<T extends string = string>({
  options,
  value,
  onChange,
  full,
}: SegmentedProps<T>) {
  return (
    <div
      style={{
        display: 'inline-flex', padding: 2,
        background: 'var(--bg-fill-1)',
        borderRadius: 10,
        width: full ? '100%' : 'auto',
      }}
    >
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            onClick={() => onChange(o.value)}
            style={{
              flex: full ? 1 : '0 0 auto',
              padding: '6px 12px', minHeight: 32,
              borderRadius: 8,
              background: active ? 'var(--bg-surface)' : 'transparent',
              boxShadow: active
                ? '0 1px 2px rgba(0,0,0,.06), 0 0 0 .5px rgba(0,0,0,.04)'
                : 'none',
              color: 'var(--fg-primary)',
              fontSize: 13, fontWeight: active ? 600 : 500,
              transition: 'all var(--dur-fast) var(--ease-out)',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 5,
              border: 0, cursor: 'pointer',
            }}
          >
            {o.icon}
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export default Segmented;
